/**
 * Hamburger menu open/close functionality.
 */
(function(){
    var b = document.body;
    // toggle open/close
    b.addEventListener('click', function(e){
        var isNavTrigger = e.target.closest('.hamburger-trigger');
        var navBodyElem = document.querySelector('.hamburger-nav__body');
        var isNavBody = e.target == navBodyElem;
        var isCloseLink = e.target.closest('.close');
        if (!isNavTrigger && !isNavBody && !isCloseLink) return;
        e.preventDefault();
        b.classList.remove('hamburger-nav--on-complete', 'hamburger-nav--off-complete');
        if (b.classList.contains('hamburger-nav--on')) {
            b.classList.remove('hamburger-nav--on');
            b.classList.add('hamburger-nav--off');
        } else {
            b.classList.remove('hamburger-nav--off');
            b.classList.add('hamburger-nav--on');
        }
        // delay setting focus so that any animation can complete
        if (e.target.closest('.search-trigger')) setTimeout(function() {
            navBodyElem.querySelector('.search input[type="text"]').focus();
        }, 500);
        navBodyElem.scrollTop = 0;
    });
    // @see https://developer.mozilla.org/en-US/docs/Web/API/Element/transitionend_event
    b.addEventListener('transitionend', function(e) {
        if (!e.target.closest('.hamburger-nav__underlay')) return;
        b.classList.remove('hamburger-nav--on-complete', 'hamburger-nav--off-complete');
        // add *-complete css class, used primarily to trigger display and/or visibility changes
        if (b.classList.contains('hamburger-nav--on')) b.classList.add('hamburger-nav--on-complete');
        else b.classList.add('hamburger-nav--off-complete');
    }, false);
})();

/**
 * Add helper css class "[sub-]menu-count-[n]"
 */
(function(){
    document.querySelectorAll('.menu').forEach(function(elem){
        elem.classList.add('menu-count-' + elem.childElementCount);
    });
    document.querySelectorAll('.sub-menu').forEach(function(elem){
        elem.classList.add('sub-menu-count-' + elem.childElementCount);
    });
})();

/**
 * Check sub-menu position/bounds and snap-right or snap-left to the container/row.
 */
(function(){
    function snapSubmenu() {
        var navElem = document.querySelector('#primary-menu');
        var elems = navElem ? navElem.querySelectorAll('.menu-item-depth-0 > .sub-menu-container') : [];
        elems.forEach(function(elem){
            var hInfo = elem.closest('.site-header__nav').getBoundingClientRect();
            var menuItemElem = elem.closest('.menu-item-depth-0');
            menuItemElem.classList.remove('snap-left', 'snap-right');
            var info = elem.getBoundingClientRect();
            // check right bounds
            if (info.right >= hInfo.right) {
                menuItemElem.classList.add('snap-right');
            }
            // then check left bounds, default to left aligned (over right aligned)
            // because most browsers allow you to scroll past the right-edge but usually not past the left-edge
            if (info.left <= hInfo.left) {
                menuItemElem.classList.remove('snap-right');
                menuItemElem.classList.add('snap-left');
            }
        });
    }
    snapSubmenu();
    // Use snapSubmenu() again if browser window size changes, throttle "resize" event to every 500ms
    var mq = window.matchMedia('(min-width: 992px)'), ref;
    window.addEventListener('resize', function() {
        if (!mq.matches) return;
        clearTimeout(ref);
        ref = setTimeout(snapSubmenu, 500);
    });
})();

/**
 * Pitbar functionality.
 * 
 * When scroll direction changes, show or hide the site-header.
 * 
 * Note that the code below only adds css classes "scrolling-up", "scrolling-down" 
 * to the body when scrolling direction changes and offset is triggered.
 * 
 * @see https://ux.stackexchange.com/questions/57990/how-usable-are-bars-that-disappear-reappear-on-scroll
 */
(function(){
    var offsetUp = 120;
    var offsetDown = 180;
    var direction = 'up';
    var directionChange = false;
    var lastScrollTop = getScrollTop();
    var offsetScrollTop = getScrollTop();
    function getScrollTop() {
        return window.pageYOffset || document.documentElement.scrollTop;
    }
    function setScrollingDirection() {
        var scrollTop = getScrollTop();
        // determine new scrolling direction when direction changes
        if (scrollTop > lastScrollTop && 'up' == direction) {
            // scrolling down
            direction = 'down';
            directionChange = true;
            offsetScrollTop = lastScrollTop + offsetDown;
        } else if (scrollTop < lastScrollTop && 'down' == direction ) {
            // scrolling up
            direction = 'up';
            directionChange = true;
            offsetScrollTop = lastScrollTop - offsetUp;
        }
        lastScrollTop = (scrollTop <= 0) ? 0 : scrollTop;
        // on direction change check if scrolling past offset
        if (directionChange) {
            if ('down' == direction && scrollTop > offsetScrollTop) {
                // scrolling down
                directionChange = false;
                document.body.classList.remove('scrolling-up');
                document.body.classList.add('scrolling-down');
            } else if ('up' == direction && scrollTop < offsetScrollTop) {
                directionChange = false;
                document.body.classList.remove('scrolling-down');
                document.body.classList.add('scrolling-up');
            }
        }
    }
    window.addEventListener('scroll', setScrollingDirection, false);
})();
